import { render, staticRenderFns } from "./color_input.vue?vue&type=template&id=0877bc4c&scoped=true&"
import script from "./color_input.vue?vue&type=script&lang=js&"
export * from "./color_input.vue?vue&type=script&lang=js&"
import style0 from "./color_input.vue?vue&type=style&index=0&id=0877bc4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877bc4c",
  null
  
)

export default component.exports